










































































import { Vue, Component } from "vue-property-decorator";

import firebase from "@/firebase";
import { PomodoroStatus } from "@/enums/PomodoroStatus"; // eslint-disable-line
import { mapState } from "vuex";

import { PomodoroMixin } from "@/mixin";
import HowToUse from "@/components/HowToUse.vue";

@Component({
  components: {
    HowToUse,
  },
  computed: mapState([
    "workMinutes",
    "totalTime",
    "shortBreakMinutes",
    "longBreakMinutes",
    "timerActive",
    "workCount",
    "currentStatus",
    "notificationEnabled",
    "wakeLockEnabled",
    "soundEnabled",
    "vibrationEnabled",
  ]),
  mixins: [PomodoroMixin],
})
export default class Timer extends Vue {
  private workMinutes!: number;
  private totalTime!: number;
  private shortBreakMinutes!: number;
  private longBreakMinutes!: number;
  private timerActive!: boolean;
  private workCount!: number;
  private currentStatus!: PomodoroStatus;
  private notificationEnabled!: boolean;
  private wakeLockEnabled!: boolean;
  private soundEnabled!: boolean;
  private vibrationEnabled!: boolean;

  // methods
  private startTimer() {
    this.$ga.event("timer", "click", "start");
    this.$store.dispatch("startTimer");
  }

  private pauseTimer() {
    this.$ga.event("timer", "click", "pause");
    this.$store.dispatch("pauseTimer");
  }

  private resetTimer() {
    if (!window.confirm("Do you really want to reset?")) {
      return;
    }
    this.$ga.event("timer", "click", "reset");
    this.$store.dispatch("resetTimer");
  }

  private async pushModal() {
    if (!firebase.isNotificationSupported()) {
      alert("Sorry.\nThis browser doesn't support push notification");
      return;
    }

    try {
      await this.$store.dispatch("requestUserNotificationPermission");
      this.$ga.event("timer", "click", "notification-setting");
    } catch (err) {
      if (
        confirm(
          `Please turn notification on by browser setting.\nShow the help page in a new tab.\nError detail: ${err.message}`
        )
      ) {
        window.open(
          "https://support.google.com/chrome/answer/3220216",
          "_blank",
          "noopener"
        );
      }
    }
  }

  private async wakeLockModal() {
    this.$ga.event("timer", "click", "wake-lock-setting");
    this.$store.dispatch("changeWakeLockStatus");
  }

  private soundModal() {
    this.$ga.event("timer", "click", "sound-setting");
    this.$store.dispatch("changeSoundStatus");
  }

  private vibrationModal() {
    this.$ga.event("timer", "click", "vibration-setting");
    this.$store.dispatch("changeVibrationStatus");
  }

  // computed
  private get display(): string {
    return this.$store.getters.getDisplayTime;
  }
}
